module.exports = __webpack_public_path__ + "static/media/videom.9e8c99cf.mp4";